import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent, Notification } from './notification.component';
import { NotificationService } from '../../../services/notification.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notification-container',
  standalone: true,
  imports: [CommonModule, NotificationComponent],
  template: `
    <div class="notification-container" [class.has-notifications]="notifications.length > 0">
      <app-notification 
        *ngFor="let notification of notifications; trackBy: trackByFn"
        [notification]="notification"
        (dismiss)="onDismiss($event)"
        (actionClick)="onActionClick($event)">
      </app-notification>
    </div>
  `,
  styles: [`
    .notification-container {
      position: fixed;
      top: 24px;
      right: 24px;
      z-index: 10000;
      pointer-events: none;
      max-width: 500px;
      width: 100%;
    }

    .notification-container.has-notifications {
      pointer-events: auto;
    }

    .notification-container app-notification {
      display: block;
      pointer-events: auto;
    }

    /* Mobile responsive */
    @media (max-width: 768px) {
      .notification-container {
        top: 16px;
        right: 16px;
        left: 16px;
        max-width: none;
      }
    }

    /* Tablet responsive */
    @media (max-width: 1024px) and (min-width: 769px) {
      .notification-container {
        right: 16px;
        max-width: 400px;
      }
    }
  `]
})
export class NotificationContainerComponent implements OnInit, OnDestroy {
  notifications: Notification[] = [];
  private subscription?: Subscription;

  constructor(private notificationService: NotificationService) {}

  ngOnInit() {
    this.subscription = this.notificationService.notifications$.subscribe(
      notifications => this.notifications = notifications
    );
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  onDismiss(id: string) {
    this.notificationService.dismiss(id);
  }

  onActionClick(notification: Notification) {
    // Action is already handled in the notification component
    // This is just for potential future use
  }

  trackByFn(index: number, notification: Notification) {
    return notification.id;
  }
}